import { render, staticRenderFns } from "./DayRaceList.vue?vue&type=template&id=2e215258&scoped=true"
import script from "./DayRaceList.vue?vue&type=script&lang=js"
export * from "./DayRaceList.vue?vue&type=script&lang=js"
import style0 from "./DayRaceList.vue?vue&type=style&index=0&id=2e215258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e215258",
  null
  
)

export default component.exports